import { createContext, useContext } from "react";
import { NOOP_ANALYTICS } from "./analytics.js";
const AnalyticsContext = createContext(null);
/**
 * Returns the call-site analytics API, or a no-op one for apps that don't mount
 * <AnalyticsProvider/>, so callers never need to null-check.
 */
export function useAnalytics() {
    return useContext(AnalyticsContext) ?? NOOP_ANALYTICS;
}
export { AnalyticsContext };
